export const cancelPaymentRequestCode = {
    "curl": {
      "request": `curl -X 'POST'
'https://demo-api.westpay.se/in-store/api/v1/cancel'
-H 'accept: text/plain'
-H 'Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04'
-H 'Ocp-Apim-Subscription-Key: 76591d32138f4f60b580db9ec9167f1d'
-H 'Content-Type: application/json'
-d '{
    "terminalId": "80000782"
}'`
    },
    "java": {
      "request": `import java.io.BufferedReader;
import java.io.InputStreamReader;
import java.net.HttpURLConnection;
import java.net.URL;
import java.util.Base64;
import com.google.gson.Gson;
      
public class CancellationExample {
    public static void main(String[] args) {
        try {
            // Set the request URL
            URL url = new URL("https://demo-api.westpay.se/in-store/api/v1/cancel");
                  
            // Open a connection
            HttpURLConnection connection = (HttpURLConnection) url.openConnection();
                  
            // Set the request method to POST
            connection.setRequestMethod("POST");
                  
            // Set the request headers
            connection.setRequestProperty("accept", "text/plain");
            connection.setRequestProperty("Ocp-Apim-Subscription-Key", "76591d32138f4f60b580db9ec9167f1d");
            connection.setRequestProperty("Authorization", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04");
            connection.setRequestProperty("Content-Type", "application/json");
                  
            // Enable input and output streams
            connection.setDoInput(true);
            connection.setDoOutput(true);
                  
            // Create the request body object
            CancelRequest requestBodyObj = new CancelRequest("80000782");
                  
            // Convert the request body object to JSON string
            Gson gson = new Gson();
            String requestBody = gson.toJson(requestBodyObj);
                  
            // Set the request body
            connection.getOutputStream().write(requestBody.getBytes("UTF-8"));
                  
            // Send the request
            int statusCode = connection.getResponseCode();
                
            // Read the response
            BufferedReader reader;
            if (statusCode >= 200 && statusCode < 300) {
                reader = new BufferedReader(new InputStreamReader(connection.getInputStream()));
            } else {
                reader = new BufferedReader(new InputStreamReader(connection.getErrorStream()));
            }
                  
            String line;
            StringBuilder response = new StringBuilder();
            while ((line = reader.readLine()) != null) {
                response.append(line);
            }
            reader.close();
                  
            // Print the response
            System.out.println("Response Code: " + statusCode);
            System.out.println("Response Body: " + response.toString());
                  
            // Close the connection
            connection.disconnect();
        } catch (Exception e) {
            e.printStackTrace();
        }
    }
}
      
class CancelRequest {
    private String terminalId;
      
    public CancelRequest(String terminalId) {
        this.terminalId = terminalId;
    }
      
    public String getTerminalId() {
        return terminalId;
    }
      
    public void setTerminalId(String terminalId) {
        this.terminalId = terminalId;
    }
}`
    },
    "C#": {
      "request": `using System;
using System.Net.Http;
using System.Text;
using System.Text.Json;
using System.Threading.Tasks;
      
class Program
{
    static async Task Main()
    {
        var httpClient = new HttpClient();
        var url = "https://demo-api.westpay.se/in-store/api/v1/cancel";
        var accessToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04";
        var ocpApiSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d";
      
        var requestData = new { terminalId = "80000782" };
        var json = JsonSerializer.Serialize(requestData);
        var content = new StringContent(json, Encoding.UTF8, "application/json");
      
        var request = new HttpRequestMessage(HttpMethod.Post, url);
        request.Headers.Add("accept", "text/plain");
        request.Headers.Add("Ocp-Apim-Subscription-Key", ocpApiSubscriptionKey);
        request.Headers.Add("Authorization", "Bearer " + accessToken);
        request.Content = content;
      
        try
        {
            var response = await httpClient.SendAsync(request);
            response.EnsureSuccessStatusCode(); // Throws an exception if the response is not successful
      
            var responseBody = await response.Content.ReadAsStringAsync();
            Console.WriteLine("Response Body: " + responseBody);
        }
        catch (HttpRequestException ex)
        {
            Console.WriteLine("HTTP Request Exception: " + ex.Message);
        }
        catch (Exception ex)
        {
            Console.WriteLine("Exception: " + ex.Message);
        }
    }
}`
    },
    "python": {
      "request": `import requests

url = "https://demo-api.westpay.se/in-store/api/v1/cancel"
      
headers = {
    "accept": "text/plain",
    "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04",
    "Ocp-Apim-Subscription-Key": "76591d32138f4f60b580db9ec9167f1d",
    "Content-Type": "application/json"
}
      
data = {
    "terminalId": "80000782"
}
      
try:
    response = requests.post(url, headers=headers, json=data)
    print("Response Code:", response.status_code)
    print("Response Body:", response.text)
except requests.exceptions.RequestException as e:
    print("An error occurred:", e)`
    },
    
    "JavaScript": {
      "request": `const url = "https://demo-api.westpay.se/in-store/api/v1/cancel";
const headers = {
  "Accept": "text/plain",
  "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04",
  "Ocp-Apim-Subscription-Key": "76591d32138f4f60b580db9ec9167f1d",
  "Content-Type": "application/json"
};
const data = {
  terminalId: "80000782"
};
      
fetch(url, {
  method: "POST",
  headers: headers,
  body: JSON.stringify(data)
})
  .then(response => {
    console.log("Response Code:", response.status);
    return response.text();
  })
  .then(responseBody => {
    console.log("Response Body:", responseBody);
  })
  .catch(error => {
    console.error("An error occurred:", error);
  });`
    }
  };

export const cancelPaymentRequestCodeResponse = `{
    "onlineAPIRefId": "23179040000954"
}`;